import { apiFetch } from './client';
import type { Me } from '$lib/state/session.svelte';

export const fetchMe = () => apiFetch<Me>('/me');
